/*========================================================================
 * $Id$
 *
 * Copyright © Mindbreeze Software GmbH, Linz, Austria, 2005-2013
 *
 * Der Nutzer des Computerprogramms anerkennt, dass der oben stehende
 * Copyright-Vermerk im Sinn des Welturheberrechtsabkommens an der vom
 * Urheber festgelegten Stelle in der Funktion des Computerprogramms
 * angebracht bleibt, um den Vorbehalt des Urheberrechtes genuegend zum
 * Ausdruck zu bringen. Dieser Urheberrechtsvermerk darf weder vom Kunden,
 * Nutzer und/oder von Dritten entfernt, veraendert oder disloziert werden.
 * =========================================================================*/

define(["api/v2/common", "backbone", "underscore", "service/stub", "service/factory"],
function(Common, Backbone, _, Stub, ServiceFactory, Search){

  var Logout = {};
  
  var LogoutServiceStub = Logout.LogoutServiceStub = Stub.extend({
      path: "../../logout",

      call: function(channel, request, responseObserver) {
        var iframe = document.createElement("iframe");
        iframe.style.display = "none";
        iframe.src = channel.get("url") + this.path;
        iframe.title = "logout in background";
        document.body.appendChild(iframe);
      }
  });

  var LogoutServiceFactory = Logout.ServiceFactory = function() {}
  
  _.extend(LogoutServiceFactory.prototype, ServiceFactory.prototype, {
    cast: function (channel) {
      new LogoutServiceStub().cast(channel);
    },

    getLogoutPath: function () {
      return new LogoutServiceStub().path;
    }

  });

  return Logout;
});
